import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: process.env.VUE_APP_PRIMARY_COLOR,
                secondary: process.env.VUE_APP_SECONDARY_COLOR,
                avatar: process.env.VUE_APP_AVATAR_COLOR,
            }
        }
    }
});
